export const FavoritesSection = {
  title: 'Обране',
  removeButtonTitle: 'Видалити все',
  more: 'Детальніше',
  formTitle:
    "Виберіть послуги, які вас цікавлять, і заповніть форму, щоб ми могли з вами зв'язатися.",
  form: 'Форма',
};
